import { makeStyles } from '@mui/styles'
import { getPixelInREM } from '../../common/material'

export const useTableWithGenomateScoreColumnStyles = makeStyles({
    firstCell: {
        minWidth: getPixelInREM(125)
    },
    progressBarWidth: {
        width: '35%'
    },
    progressBarPadding: {
        paddingRight: getPixelInREM(12)
    }
})
